export default __webpack_public_path__ + "static/media/sad.15490d52.svg";